/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useRef, useEffect } from 'react'
import { useToasts } from 'react-toast-notifications'
import userApi from '_api/user'
import { Modal, ModalBody, ModalFooter, ModalHeader, Input } from 'reactstrap'
import { FaRegCopy, FaCheckCircle } from 'react-icons/fa'
import { getUserInfo, getRemindPaymentMessage, setRemindPaymentMessage } from '_utils/localData'

const removePaymentLink = (text) => {
  const linkRegex = /http\S+/g;

  if (linkRegex.test(text)) {
    const cleanedText = text.replace(linkRegex, '').trim();
    return cleanedText;
  }

  return text;
}

export default function RemindPaymentModel({
  order,
  toggleDetailOrder,
  modalRemindPayment,
  host,
  remindMessage,
}) {
  const paymentLink = `${process.env.REACT_APP_APP_URL}/payment-order?ref=${order?.ref}&uid=${order.uid}`
  const textDefault = remindMessage.isDefault
    ? `Hi ${order.uName}, There is a payment due for ${order.eTitle} event, organised by ${host?.name}.\n\nPayment link: ${paymentLink}`
    : `${remindMessage.message} \n \n \n ${paymentLink}`

  const { addToast } = useToasts()
  const [isEditable, setIsEditable] = useState(false)
  const [message, setMessage] = useState()
  const [messageWithLink, setMessageWithLink] = useState(textDefault)
  const [copied, setCopied] = useState(false)

  const textareaRef = useRef(null)

  const onClickEditMessage = () => setIsEditable(!isEditable)

  const setRemindMessage = async (mess) => {
    try {
      await userApi.saveRemindPaymentMessage(mess)
      setRemindPaymentMessage({
        message: mess,
        isDefault: false
      })
      addToast('change message success, it will apply for future', { appearance: 'success', autoDismiss: true })
    } catch (error) {
      addToast(error.msgResp, { appearance: 'error', autoDismiss: true })
    }
  }

  useEffect(() => {
    setMessageWithLink(textDefault)
    setMessage(textDefault)
  }, [order, remindMessage])

  const onClickSetDefaultMessage = async () => {
    await userApi.setDefaultRemindPaymentMessage()
    addToast('set default message success, it will apply for future', { appearance: 'success', autoDismiss: true })
    setRemindPaymentMessage({
      message: '',
      isDefault: true
    })
    setMessageWithLink(`Hi ${order.uName}, There is a payment due for ${order.eTitle} event, organised by ${host?.name}.\n\nPayment link: ${paymentLink}`)
    setIsEditable(false)
  }

  const onClickToggleModal = () => {
    if (isEditable && message) {
      const newMessage = removePaymentLink(message)
      setMessageWithLink(`${newMessage} \n \n \n ${paymentLink}`)
      setRemindMessage(newMessage)
      setIsEditable(false)
    } else {
      toggleDetailOrder()
      setIsEditable(false)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(messageWithLink)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Modal
      className='remind-modal'
      isOpen={modalRemindPayment}
      toggle={toggleDetailOrder}
      centered
      style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
    >
      <ModalHeader>
        <div className='remind-modal-header row'>
          <div className='remind-modal-header-info col-8'>
            <span>Send remind to</span>
            <br />
            <span>
              {order.uName} ({order.uPhone}){' '}
            </span>
          </div>
          <div className='remind-modal-header-edit-text col'>
            <span onClick={onClickEditMessage}>Edit message</span>
            <span onClick={onClickSetDefaultMessage}>reset default message</span>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className='remind-modal-body'>
        <div className='message-container'>
          {isEditable ? (
            <Input
              id='exampleText'
              name='text'
              type='textarea'
              value={messageWithLink}
              ref={textareaRef}
              onChange={(e) => {
                setMessage(e.target.value)
                setMessageWithLink(e.target.value)
              }}
            />
          ) : (
            <div>
              <p>{messageWithLink.split('\n')[0]}</p>
              <div className='remind-modal-body-link'>
                <strong>Payment link:</strong>
                <a href={paymentLink} target='_blank' rel='noopener noreferrer'>
                  {paymentLink.length > 40 ? `${paymentLink.substring(0, 40)}...` : paymentLink}
                </a>
                <span className='copy-icon' onClick={copyToClipboard}>
                  {copied ? <FaCheckCircle className='copied' /> : <FaRegCopy />}
                </span>
              </div>
            </div>
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <div className='remind-modal-footer'>
          <button className='btn btn--solid btn--solid04' onClick={onClickToggleModal}>
            Cancel
          </button>
          <button className='btn btn--org btn--org02' onClick={onClickToggleModal}>
            Ok
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}
